<template>
    <div>
      <el-card class="box-card">
        <el-form :model="EditRslEvDevice" ref="EditRslEvDeviceRef" label-width="75px">
          <el-form-item label="销售类型">
            <el-select v-model="EditRslEvDevice.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      saleTypeList: [
        { Value: '1', Label: '销售机' },
        { Value: '2', Label: '体验机' },
      ],
      EditRslEvDevice: {
        id: 0,
        saletype: '0',
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.EditRslEvDevice.id = row.Id
      this.EditRslEvDevice.saletype = row.Saletype.toString()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditRslEvDevice()
    },
    apiEditRslEvDevice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.EditRslEvDevice.id,
        saletype: that.EditRslEvDevice.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditRslEvDevice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
